import React, { useContext, useState, useEffect } from 'react'
import { Row, Col } from "react-bootstrap";
import "./scheduler.css"
import Form from 'react-bootstrap/Form';
import Element from '../InputFields/input';
import { FormContext } from '../InputFields/FormContext';
import "./scheduler.css"
import { dateParser } from '../../pages/MyFlows/flowhelper';

const Scheduler = (props) => {
    console.log("PREVIOUS SCHEDULE: ", props)
    const previousSchedule = props.previousschedule !== null ? props.previousschedule : {"Units": null, "RunEvery": null, "StartDate": null, "EndDate": null, "RepeatDay": []}
    const [daypicker, setShowDayPicker] = useState(false)
    const [showEndDate, setShowEndDate] = useState(false)
    const [scheduler_schema, setSchedulerSchema] = useState([
        {
            "id": "numberrepeat",
            "label": "Repeat after",
            "mandatory": true,
            "disabled": false,
            "placeholder": "1",
            "type": "numberinput",
            "example": "23",
            "value": previousSchedule !== null && previousSchedule.RunEvery ? previousSchedule.RunEvery : "1"
        },
        {
            "id": "selectunit",
            "label": "Units",
            "mandatory": true,
            "disabled": false,
            "placeholder": "1",
            "type": "select",
            "options": [
                {
                    "label": "Minutes",
                    "value": "minutes"
                },
                {
                    "label": "Hours",
                    "value": "hours"
                },
                {
                    "label": "Days",
                    "value": "days"
                },
                {
                    "label": "Weeks",
                    "value": "weeks"
                }

            ],
            "value": ""
            // previousSchedule.Units ? previousSchedule.Units : "minutes"
        }
    ])

    useEffect(() => {
        // console.log("props.previousschedule changed!", )
        const ss = [...scheduler_schema]
        const previousScheduleUnits = previousSchedule.Units !== null ? previousSchedule.Units : {"label": "Minutes", "value": "minutes"}
        for (let field of scheduler_schema) {
            if (field.id === "selectunit") {
                for (let option of field.options) {
                    // console.log("PREVIOUS UNITS: ", previousScheduleUnits)
                    // console.log("Option: ", option)
                    if (previousSchedule !== null && option.value === previousScheduleUnits.value) {
                        field["value"] = option
                    }
                }
            }
        }
        setSchedulerSchema(ss)
        if (previousSchedule !== null && previousScheduleUnits.value === "weeks") {
            setShowDayPicker(true)
        }

    }, [props.previousschedule])

    const [startDatepickerSchema, setStartDatepickerSchema] = useState([{
        "id": "datepicker1",
        "label": "Starts (EST)",
        "mandatory": true,
        "placeholder": "Starts",
        "type": "date",
        "example": "29/03/2023",
        "value": previousSchedule !== null && previousSchedule.StartDate ? dateParser(previousSchedule.StartDate) !== null ? dateParser(previousSchedule.StartDate) : "" : ""
    }]
    )

    const [endDatepickerSchema, setEndDatepickerSchema] = useState([
        {
            "id": "datepicker2",
            "label": "Ends (EST)",
            "mandatory": true,
            "placeholder": "Ends",
            "type": "date",
            "example": "29/03/2023",
            "value": previousSchedule !== null && previousSchedule.EndDate ? dateParser(previousSchedule.EndDate) !== null ? dateParser(previousSchedule.EndDate) : "" : ""
        }]
    )

    const [daypickerSchema, setDaypickerSchema] = useState([
        {
            "id": "1.DPS.1",
            "label": "Sunday",
            "mandatory": true,
            "disabled": false,
            "placeholder": "S",
            "type": "daypicker",
            "example": "",
            "value": ""
        },
        {
            "id": "1.DPS.2",
            "label": "Monday",
            "mandatory": true,
            "disabled": false,
            "placeholder": "M",
            "type": "daypicker",
            "example": "",
            "value": ""
        },
        {
            "id": "1.DPS.3",
            "label": "Tuesday",
            "mandatory": true,
            "disabled": false,
            "placeholder": "T",
            "type": "daypicker",
            "example": "",
            "value": ""
        },
        {
            "id": "1.DPS.4",
            "label": "Wednesday",
            "mandatory": true,
            "disabled": false,
            "placeholder": "W",
            "type": "daypicker",
            "example": "",
            "value": ""
        },
        {
            "id": "1.DPS.5",
            "label": "Thursday",
            "mandatory": true,
            "disabled": false,
            "placeholder": "T",
            "type": "daypicker",
            "example": "",
            "value": ""
        },
        {
            "id": "1.DPS.6",
            "label": "Friday",
            "mandatory": true,
            "disabled": false,
            "placeholder": "F",
            "type": "daypicker",
            "example": "",
            "value": ""
        },
        {
            "id": "1.DPS.7",
            "label": "Saturday",
            "mandatory": true,
            "disabled": false,
            "placeholder": "S",
            "type": "daypicker",
            "example": "",
            "value": ""
        }
    ]
    )
    useEffect(() => {
        const dps = [...daypickerSchema]
        if (props.previousschedule !== null) {
            for (let day of dps) {
                if (props.previousschedule.RepeatDay !== undefined) {
                    for (let rd of props.previousschedule.RepeatDay)
                        if (day["label"] === rd) {
                            day["value"] = true
                        }
                }
            }
            setDaypickerSchema(dps)
        }
    }, [props.previousschedule])


    const [scheduleElements, setScheduleElements] = useState(scheduler_schema)
    const [startDatepickerElements, setStartDatepickerElements] = useState(startDatepickerSchema)
    const [endDatepickerElements, setEndDatepickerElements] = useState(endDatepickerSchema)
    const [daypickerElements, setDaypickerElements] = useState(daypickerSchema)

    useEffect(() => {
        console.log("START DATE ELEMENTS: ", startDatepickerElements)
    }, [startDatepickerElements])

    useEffect(() => {
        console.log("END DATE ELEMENTS: ", endDatepickerElements)
    }, [endDatepickerElements])


    const handleChange = (field_id, event) => {
        const newScheduleElements = [...scheduleElements]
        const newStartDatepickerElements = [...startDatepickerElements]
        const newEndDatepickerElements = [...endDatepickerElements]
        const newDaypickerElements = [...daypickerElements]
        newScheduleElements.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                
                switch (type) {
                    case 'checkbox':
                        field['value'] = event.target.checked;
                        break;

                    case 'select':
                        field['value'] = event;
                        break;

                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            // console.log("NEW SCHEDULE ELEMENTS on CHANGE: ", newScheduleElements)
            const newSchedulerFullSchema = [...newScheduleElements]
            setScheduleElements(newSchedulerFullSchema)
        });
        for (let elem in newScheduleElements) {
            // console.log("LOOP ELEM: ", newScheduleElements[elem])
            if (newScheduleElements[elem].type == "select") {
                // console.log("IN SELECT!")
                // console.log("IN SELECT VALUE: ", newScheduleElements[elem])
                if (newScheduleElements[elem].value.value == "weeks") {
                    setShowDayPicker(true)
                } else {
                    setShowDayPicker(false)
                }
            } else if (newScheduleElements[elem].type == "checkbox") {
                // console.log(" IN CHECKBOX!")
                if (newScheduleElements[elem].value == true) {
                    // console.log("CHECKBOX value true? :", newScheduleElements[elem].value)
                    setShowEndDate(true)
                } else {
                    setShowEndDate(false)
                }
            } else {
                continue
            }
        }

        newStartDatepickerElements.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            // console.log("NEW DATE ELEMENTS on CHANGE: ", newStartDatepickerElements)
            const newStartDateFullSchema = [...newStartDatepickerElements]
            // console.log("NEW START DATE FULL SCHEMA: ", newStartDateFullSchema)
            setStartDatepickerElements(newStartDateFullSchema)
        });

        newEndDatepickerElements.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            // console.log("NEW DATE ELEMENTS on CHANGE: ", newEndDatepickerElements)
            const newEndDateFullSchema = [...newEndDatepickerElements]
            // console.log("NEW END DATE FULL SCHEMA: ", newEndDateFullSchema)
            setEndDatepickerElements(newEndDateFullSchema)
        });

        newDaypickerElements.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'daypicker':
                        field['value'] = event.target.checked;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            // console.log("NEW DAY ELEMENTS on CHANGE: ", newDaypickerElements)
            const newDayFullSchema = [...newDaypickerElements]
            // console.log("NEW DAY FULL SCHEMA: ", newDayFullSchema)
            setDaypickerElements(newDayFullSchema)
        });
        // console.log("FULL SCHEMA AT THE END: ", [...newScheduleElements, ...newStartDatepickerElements, ...newEndDatepickerElements, ...newDaypickerElements])
        props.getscheduler([...newScheduleElements, ...newStartDatepickerElements, ...newEndDatepickerElements, ...newDaypickerElements])
    }

    return (
        <FormContext.Provider value={{ handleChange }}>
            <Form className='no-padding'>
                <Row className="no-gutter">
                    {
                        scheduleElements &&
                        scheduleElements.map((field, i) =>
                            <Element
                                key={i}
                                field={field}
                                md={
                                    field.type == "number"
                                        ?
                                        6
                                        :
                                        (field.type == "checkbox"
                                            ?
                                            2
                                            :
                                            (field.type == "select" ? 6 : 6))}
                            />)
                    }

                    {
                        daypicker
                            ?
                            <Row className="daypicker-container">
                                <label className="custom-daypicker-label daypicker-label move-left" htmlFor="exampleDaypicker">Repeat on</label>
                                <Row className="no-gutter daypicker-input-holder">
                                    {daypickerElements &&
                                        daypickerElements.map((field, i) =>
                                            <Element
                                                key={i}
                                                field={field}
                                                md={1}
                                            />)}
                                </Row>
                            </Row>
                            :
                            <></>
                    }

                    {
                        [...startDatepickerElements, ...endDatepickerElements] &&
                        [...startDatepickerElements, ...endDatepickerElements].map((field, i) =>
                            <Element
                                key={i}
                                field={field}
                                md={6}
                            />)
                    }

                </Row>
            </Form>
        </FormContext.Provider>
    )
}

export default Scheduler